import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/components/DashboardLayout'
import Dashboard from '@/components/Dashboard'
import Settings from '@/components/Settings'
import Domains from '@/components/Domains'
import AuthenticatedDomains from '@/components/AuthenticatedDomains'
import ContactList from '@/components/ContactList'
import Contacts from '@/components/Contacts'
import CampaignList from '@/components/CampaignList'
import CampaignTemplateList from '@/components/CampaignTemplateList'
import WebsiteList from '@/components/WebsiteList'
import WorkerList from '@/components/WorkerList'
import SuppressionList from '@/components/SuppressionList'
import BulkListUpload from '@/components/BulkListUpload'
import EventSummary from '@/components/EventSummary'
import EventSummaryReceiving from '@/components/EventSummaryReceiving'
import EventSummaryDomain from '@/components/EventSummaryDomain'
import EventSummaryResponse from '@/components/EventSummaryResponse'
import Template from '@/components/Template'
import Stats from '@/components/Stats'
import ProxyList from '@/components/ProxyList'
import EngagementStats from '@/components/EngagementStats'
import AccountStats from '@/components/AccountStats'

import Auth from "@/components/Auth"

Vue.use(Router)

var router = new Router({
    routes: [
        { path: '/auth', name: 'auth', component: Auth },
        {
            path: '/',
            name: 'layout',
            component: DashboardLayout,
            children: [
                { path: '/', name: 'dashboard', component: Dashboard },
                { path: '/domains', name: 'domains', component: Domains },
                { path: '/templates', name: 'templates', component: Template },
                { path: '/stats', name: 'stats', component: Stats },
                { path: '/engagement_stats', name: 'engagement_stats', component: EngagementStats },
                { path: '/account_stats', name: 'account_stats', component: AccountStats },
                { path: '/event_summary/receiving', name: 'event_summary_receiving', component: EventSummaryReceiving },
                { path: '/event_summary', name: 'event_summary', component: EventSummary },
                { path: '/event_summary/:day/:domain/:event', name: 'event_summary_domain', component: EventSummaryDomain },
                { path: '/event_summary/:day/:domain/:event/list', name: 'event_summary_response', component: EventSummaryResponse },
                { path: '/authenticated_domains', name: 'authenticated_domains', component: AuthenticatedDomains },
                { path: '/settings', name: 'settings', component: Settings },
                { path: '/contact_lists', name: 'contact_lists', component: ContactList },
                { path: '/bulk_list_upload', name: 'bulk_list_upload', component: BulkListUpload },
                { path: '/contact/:id', name: 'contacts', component: Contacts },
                { path: '/campaigns', name: 'campaign_list', component: CampaignList },
                { path: '/campaign_templates', name: 'campaign_template_list', component: CampaignTemplateList },
                { path: '/websites', name: 'website_list', component: WebsiteList },
                { path: '/workers', name: 'worker_list', component: WorkerList },
                { path: '/proxy', name: 'proxy_list', component: ProxyList },
                { path: '/suppression_list/:type', name: 'suppression_list', component: SuppressionList }
            ]
        },
    ]
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js